import * as React from 'react';
import {
    Box,
    TextInput,
    Group,
    Button,
    Textarea,
    Switch
} from '@mantine/core'
import  { useForm, isNotEmpty } from "@mantine/form";
import axios from 'axios';
import type { IResponse } from "../../types/api";
import { useNavigate } from "react-router-dom";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import { showMessage } from "../../lib/notification";
import type { IArticle } from "./types";
import FileUpload from "../../components/file-upload";
import { IMAGE_MIME_TYPE } from "@mantine/dropzone";
import Page from "../../components/layout/Page";
import { assignFiles } from "../../utils/form";
import { useFormStyles } from "../../styles/form";

interface FormValues extends Pick<IArticle, 'title' | 'shortContent' | 'content' | 'isPublished'> {
    image: File | null;
    mobileImage: File | null;
}

interface IParams extends Omit<FormValues, 'image' | 'mobileImage'> {
    image?: string;
    mobileImage?: string;
}

const CreateArticle = () => {

    const { classes } = useFormStyles();
    const navigate = useNavigate();

    const form = useForm<FormValues>({
        initialValues: {
            title: '',
            content: '',
            shortContent: '',
            image: null,
            isPublished: false,
            mobileImage: null
        },

        validate: {
            title: isNotEmpty('Гарчиг оруулна уу'),
            content: isNotEmpty('Мэдээ оруулна уу'),
        },
    });

    const handleSubmit = async (values: FormValues) => {
        const files = await assignFiles({
            image: values.image,
            mobileImage: values.mobileImage,
        }, 'article');
        const params: IParams = {
            ...values,
            ...files
        }
        const { data } = await axios.post<IResponse<any>>(API_ROUTE, params);
        if (data.statusCode === 200) {
            navigate(CLIENT_ROUTE);
            showMessage('Амжилттай', 'green');
        } else {
            showMessage('Алдаа гарлаа');
        }
    }

    return (
        <Page>
            <Page.Header title={`${CLIENT_TITLE} үүсгэх`} backRoute={CLIENT_ROUTE}/>
            <Page.Body>
                <Box sx={{ maxWidth: 500 }} mx="auto" my={'xl'}>
                    <form onSubmit={form.onSubmit(handleSubmit)} className={classes.form}>
                        <TextInput
                            withAsterisk
                            label="Гарчиг"
                            placeholder="Гарчиг оруулна уу"
                            {...form.getInputProps('title')}
                        />

                        <Textarea
                            label="Товч"
                            placeholder="Товч"
                            {...form.getInputProps('shortContent')}
                        />

                        <Textarea
                            autosize
                            withAsterisk
                            label="Мэдээ"
                            placeholder="Мэдээ оруулна уу"
                            {...form.getInputProps('content')}
                        />

                        <FileUpload
                            value={form.values.image}
                            onChange={(value) => {
                                form.setFieldValue('image', value);
                            }}
                            label='Зураг'
                            accept={IMAGE_MIME_TYPE}
                        />

                        <FileUpload
                            value={form.values.mobileImage}
                            onChange={(value) => {
                                form.setFieldValue('mobileImage', value);
                            }}
                            label='Утасны зураг'
                            accept={IMAGE_MIME_TYPE}
                        />

                        <Switch
                            label="Нийтлэгдсэн эсэх"
                            {...form.getInputProps('isPublished', { type: 'checkbox' })}
                        />
                    </form>
                </Box>
            </Page.Body>
            <Page.Footer>
                <Group position="right" mt="md">
                    <Button color='color-secondary' onClick={() => form.onSubmit(handleSubmit)()}>Хадгалах</Button>
                </Group>
            </Page.Footer>
        </Page>
    );
};

export default CreateArticle;